import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SocketProvider } from './contexts/SocketContext';
import PublicDisplay from './components/PublicDisplay';
import EntityDisplay from './components/EntityDisplay';
import './App.css';

// Dark theme for public displays
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#ff4081',
    },
    background: {
      default: '#000000',
      paper: '#1a1a1a',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '4rem',
      fontWeight: 300,
    },
    h2: {
      fontSize: '3rem',
      fontWeight: 300,
    },
    h3: {
      fontSize: '2.5rem',
      fontWeight: 300,
    },
    h4: {
      fontSize: '2rem',
      fontWeight: 400,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 400,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#000000',
          color: '#ffffff',
        },
      },
    },
  },
});

function App() {
  // /entity/<vertical>/<id> → standalone-vertical board (poll-based, no socket);
  // anything else → the core-queue socket display.
  const isEntity = window.location.pathname.split('/').filter(Boolean)[0] === 'entity';
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isEntity ? (
        <EntityDisplay />
      ) : (
        <SocketProvider>
          <PublicDisplay />
        </SocketProvider>
      )}
    </ThemeProvider>
  );
}

export default App;